export const KYC_STEPS = Object.freeze({
  INTRO: "INTRO",
  PERSONAL_INFORMATION: "PERSONAL_INFORMATION",
  COUNTRY: "COUNTRY",
  DOCUMENT_TYPE: "DOCUMENT_TYPE",
  DOCUMENT_PREPARATION: "DOCUMENT_PREPARATION",
  DOCUMENT_CAPTURE: "DOCUMENT_CAPTURE",
  DOCUMENT_REVIEW: "DOCUMENT_REVIEW",
  DOCUMENT_BACK_PREPARATION: "DOCUMENT_BACK_PREPARATION",
  SELFIE: "SELFIE",
  LIVENESS: "LIVENESS",
  ADDRESS_PROOF_PREPARATION: "ADDRESS_PROOF_PREPARATION",
  ADDRESS_PROOF: "ADDRESS_PROOF",
  FINAL_REVIEW: "FINAL_REVIEW",
  SUBMITTING: "SUBMITTING",
  PROCESSING: "PROCESSING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
  RETRY: "RETRY",
  EXPIRED: "EXPIRED",
});

export const ACTIVE_KYC_STEPS = [
  KYC_STEPS.INTRO,
  KYC_STEPS.DOCUMENT_TYPE,
  KYC_STEPS.DOCUMENT_PREPARATION,
  KYC_STEPS.DOCUMENT_CAPTURE,
  KYC_STEPS.DOCUMENT_REVIEW,
  KYC_STEPS.DOCUMENT_BACK_PREPARATION,
  KYC_STEPS.SELFIE,
  KYC_STEPS.LIVENESS,
  KYC_STEPS.ADDRESS_PROOF_PREPARATION,
  KYC_STEPS.ADDRESS_PROOF,
  KYC_STEPS.PROCESSING,
];

export const KYC_STEP_TRANSLATION_KEYS = {
  [KYC_STEPS.INTRO]: "intro",
  [KYC_STEPS.PERSONAL_INFORMATION]: "personalInformation",
  [KYC_STEPS.COUNTRY]: "country",
  [KYC_STEPS.DOCUMENT_TYPE]: "documentType",
  [KYC_STEPS.DOCUMENT_PREPARATION]: "documentPreparation",
  [KYC_STEPS.DOCUMENT_CAPTURE]: "documentCapture",
  [KYC_STEPS.DOCUMENT_REVIEW]: "documentReview",
  [KYC_STEPS.DOCUMENT_BACK_PREPARATION]: "documentBackPreparation",
  [KYC_STEPS.SELFIE]: "selfie",
  [KYC_STEPS.LIVENESS]: "liveness",
  [KYC_STEPS.ADDRESS_PROOF_PREPARATION]: "addressProofPreparation",
  [KYC_STEPS.ADDRESS_PROOF]: "addressProof",
  [KYC_STEPS.FINAL_REVIEW]: "finalReview",
  [KYC_STEPS.SUBMITTING]: "submitting",
  [KYC_STEPS.PROCESSING]: "processing",
  [KYC_STEPS.SUCCESS]: "success",
  [KYC_STEPS.FAILED]: "failed",
  [KYC_STEPS.RETRY]: "retry",
  [KYC_STEPS.EXPIRED]: "expired",
};

const STATUS_TO_STEP = {
  COMPLETED: KYC_STEPS.SUCCESS,
  SUCCESS: KYC_STEPS.SUCCESS,
  FAILED: KYC_STEPS.FAILED,
  EXPIRED: KYC_STEPS.EXPIRED,
  PROCESSING: KYC_STEPS.PROCESSING,
};

const STEP_ALIASES = {
  ID_BACK_PREPARATION: KYC_STEPS.DOCUMENT_BACK_PREPARATION,
  BILL: KYC_STEPS.ADDRESS_PROOF,
  BILL_UPLOAD: KYC_STEPS.ADDRESS_PROOF,
  BILL_PREPARATION: KYC_STEPS.ADDRESS_PROOF_PREPARATION,
  PROOF_OF_ADDRESS: KYC_STEPS.ADDRESS_PROOF,
};

export function normalizeKycStep(value) {
  if (!value) return KYC_STEPS.INTRO;

  const normalized = String(value)
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, "_");

  return (
    KYC_STEPS[normalized] ||
    STEP_ALIASES[normalized] ||
    STATUS_TO_STEP[normalized] ||
    KYC_STEPS.INTRO
  );
}

export function getSessionStep(session) {
  const terminalStep =
    STATUS_TO_STEP[String(session?.status || "").toUpperCase()];
  const sessionStep = normalizeKycStep(session?.currentStep || session?.step);

  if (terminalStep) return terminalStep;
  if (
    [
      KYC_STEPS.PERSONAL_INFORMATION,
      KYC_STEPS.COUNTRY,
      KYC_STEPS.DOCUMENT_PREPARATION,
    ].includes(sessionStep)
  ) {
    return KYC_STEPS.DOCUMENT_CAPTURE;
  }
  if (sessionStep === KYC_STEPS.SELFIE) {
    return KYC_STEPS.LIVENESS;
  }
  if ([KYC_STEPS.FINAL_REVIEW, KYC_STEPS.SUBMITTING].includes(sessionStep)) {
    return KYC_STEPS.PROCESSING;
  }

  return sessionStep;
}
